export enum ExportRange {
  CurrentPage = 0,
  AllPages = 1,
}

export enum ExportFileFormat {
  Excel = 'xlsx',
  CSV = 'csv',
  JSON = 'json'
}

export enum ExportTaskStatus {
  Busy = 0,
  Complete = 1,
  Canceled = 2,
}
